module.exports = __webpack_public_path__ + "/static/images/file_ppt.png";